
import { createClient } from '@supabase/supabase-js';
import { useState, useEffect } from 'react';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

export const useSupabase = () => {
  return { supabase };
};

// 파일명을 안전한 형태로 변환하는 함수
const sanitizeFileName = (fileName: string): string => {
  // 파일 확장자 추출
  const lastDotIndex = fileName.lastIndexOf('.');
  const name = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
  const extension = lastDotIndex > 0 ? fileName.substring(lastDotIndex) : '';
  
  // 한글, 특수문자 제거하고 영문, 숫자, 하이픈, 언더스코어만 허용
  const sanitizedName = name
    .replace(/[^a-zA-Z0-9\-_]/g, '')
    .toLowerCase();
  
  // 빈 문자열이면 기본값 사용
  const finalName = sanitizedName || 'image';
  
  return `${finalName}${extension}`;
};

export const uploadImage = async (file: File, path: string) => {
  // 파일명 안전하게 변환
  const sanitizedPath = sanitizeFileName(path);
  
  const { data, error } = await supabase.storage
    .from('menu-images')
    .upload(sanitizedPath, file, {
      cacheControl: '3600',
      upsert: false
    });

  if (error) {
    throw error;
  }

  const { data: { publicUrl } } = supabase.storage
    .from('menu-images')
    .getPublicUrl(data.path);

  return publicUrl;
};

export const deleteImage = async (path: string) => {
  const { error } = await supabase.storage
    .from('menu-images')
    .remove([path]);

  if (error) {
    throw error;
  }
};
